import { TNativeAudioNode, TNativeContext } from '../types';

export const isOwnedByContext = (nativeAudioNode: TNativeAudioNode, nativeContext: TNativeContext): boolean => {
    return nativeAudioNode.context === nativeContext;
};
